module.exports = __webpack_public_path__ + "img/13.3d6c7c41.jpg";